import React from 'react';
import { formatConcreteDeliveryDate } from 'utils/deliveryDates';

export const slotValue = (date, time) => (date && time ? `${date}|${time}` : '');

export const parseSlotValue = (value) => {
    const [date = '', time = ''] = String(value || '').split('|');
    return { date, time };
};

export const formatFee = (amount) => `$${Math.abs(amount).toFixed(2)}`;

const selectStyle = {
    width: '100%',
    padding: '8px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '16px',
    backgroundColor: '#fff',
    cursor: 'pointer'
};

// One dropdown of date · time combinations, like checkout's "Deliver everything on"
// slots: [{ date, time, suffix }]
const DeliverySlotSelect = ({ id, slots, value, onChange, placeholder }) => (
    <select id={id} value={value} onChange={(e) => onChange(e.target.value)} style={selectStyle}>
        {placeholder && <option value="">{placeholder}</option>}
        {slots.map(({ date, time, suffix }) => (
            <option key={slotValue(date, time)} value={slotValue(date, time)}>
                {formatConcreteDeliveryDate(date)} · {time}{suffix || ''}
            </option>
        ))}
    </select>
);

export default DeliverySlotSelect;
